import React, { useEffect } from 'react';
import { InputNumber, Form, Select } from 'antd';


import TextArea from 'antd/lib/input/TextArea';
import { JSXMap } from 'fennec-ui';

const { Option } = Select;

export default function VivodSoScheta(props) {
    const { object, form } = props;
    useEffect(() => {
        form.resetFields();
    }, []);

    const getOstatok = (acc) => {
        if (acc.ostatok >= 0) {
            return (<span style={{ color: "rgb(63, 134, 0)" }}>
                + {Math.abs(Number(acc.ostatok.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
            </span>)
        }
        if (acc.ostatok < 0) {
            return (<span style={{ color: "red" }}>
                - {Math.abs(Number(acc.ostatok.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
            </span>)
        }
    }

    const accounts = JSXMap([object], (acc, idx) => {
        if (acc) {
            return (<Option key={acc.ID} value={acc.ID}>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                    <div>№{acc.nomerAkkaunta}</div>
                    <div style={{ textAlign: "right" }}>{getOstatok(acc)}</div>
                </div>
            </Option>)
        }
    });
    return (
        <>
            {props.subheader}
            {object && <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    accountID: (object && object.ID)?object.ID:undefined
                }}
            >
                <Form.Item label="Счет"
                    name="accountID"
                    rules={[{ required: true, message: 'Пожалуйста, укажите счет!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {accounts}
                    </Select>
                </Form.Item>
                <Form.Item label="Сумма"
                    name="summa"
                    rules={[{ required: true, message: 'Пожалуйста, укажите сумму!' }]}
                >
                    <InputNumber min={0} style={{minWidth:"200px"}}/>
                </Form.Item>
                <Form.Item label="Примечание"
                    name="primechanie"
                    rules={[{ required: false, message: 'Пожалуйста, укажите примечание!' }]}
                >
                    <TextArea maxLength={512} />
                </Form.Item>
            </Form>}
        </>
    );
}
